import React, { useEffect, useState } from "react";

import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import { useTranslation } from "react-i18next";
const RoleInfo = (props) => {
  const {
    formik,
    next,
    bankGroupList,
    bankList,
    setBankId,
    setBranchId,
    branchList,
    handleError,
    handleCompletion,
    handleSelectedBank,
    location,
  } = props;
  const {
    bankGroupId: bankGroupIdValue,
    bankId: bankIdValue,
    branchId: branchIdValue,
  } = formik.values;
  const {
    bankGroupId: bankGroupIdError,
    bankId: bankIdError,
    branchId: branchIdError,
  } = formik.errors;
  const { bankId: bankIdTouch, branchId: branchIdTouch } = formik.touched;
  const STEP_ID = 1;
  const { t } = useTranslation();
  const [disabled, setDisabled] = useState(() =>
    bankGroupIdValue &&
      bankIdValue &&
      branchIdValue &&
      !bankIdError &&
      !bankGroupIdError &&
      !branchIdError
      ? false
      : true
  );

  useEffect(() => {
    setDisabled(
      bankGroupIdValue &&
        bankIdValue &&
        branchIdValue &&
        !bankIdError &&
        !bankGroupIdError &&
        !branchIdError
        ? false
        : true
    );
  }, [
    bankGroupIdValue,
    bankIdValue,
    branchIdValue,
    bankIdError,
    bankGroupIdError,
    branchIdError,
  ]);

  useEffect(() => {
    if (!disabled) {
      handleError(STEP_ID, false);
      handleCompletion(STEP_ID, true);
    } else if (disabled) {
      handleError(STEP_ID, true);
      handleCompletion(STEP_ID, false);
    }
  }, [disabled]);

  useEffect(() => {
    const { branchId = "" } = branchList[0] || {};
    formik.setFieldValue("branchId", branchId);
  }, [branchList]);

  return (
    <>
      <div className="inputField mt-2">
        <SearchableSelect
          placeholder="Select Bank Group"
          name="bankGroupId"
          handleChange={(key, value) => {
            formik.setFieldValue(key, value);
          }}
          options={bankGroupList}
          value={bankGroupIdValue}
          defaultValue="Genossenschaftsbanken"
          errors={bankGroupIdValue > 10 && bankGroupIdError}
        />
      </div>

      {location?.hash !== "#AU" &&
        <>
          <div className="inputField mt-2">
            <SearchableSelect
              placeholder={t("select-bank")}
              name="bankId"
              handleChange={(key, value, rest) => {
                let { label = "" } = rest || {};
                formik.setFieldValue(key, value);
                handleSelectedBank(label);
                setBankId(value);
              }}
              options={bankList?.map((bank) => {
                return { value: bank.bankId, label: bank.bankName };
              })}
              value={bankIdValue}
              errors={bankIdTouch && bankIdError}
            />
          </div>
          <div className="inputField mt-2 d-none">
            <SearchableSelect
              placeholder={t("select-branch")}
              name="branchId"
              handleChange={(key, value) => {
                formik.setFieldValue(key, value);
                setBranchId(value);
              }}
              options={branchList?.map((branch) => {
                return { value: branch.branchId, label: branch.branchName };
              })}
              value={branchIdValue}
              errors={branchIdTouch && branchIdError}
            />
          </div>
        </>}
      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            ...(bankGroupIdValue === "227f28af-5e82-4ba9-b5bf-685dadfbf5e3" ? false : disabled && { filter: "  opacity(30%)" }),
          }}
          disabled={bankGroupIdValue === "227f28af-5e82-4ba9-b5bf-685dadfbf5e3" ? false : disabled}
          onClick={next}
        >
          {t("next")}
        </button>
      </div>
    </>
  );
};

export default RoleInfo;
